module.exports = __webpack_public_path__ + "static/20250328_Investor_Update-99c451d06509be4e47fa19f5998ecdcc.pdf";